<div class="bp-modal mod-lg">
	<bp-modal-header [title]="'send_to_CRYPTOSYMBOL_contact' | translate: [tradable.name]" class="font-semibold">
		<a (click)="onBackButtonClick()" (keydown.enter)="onBackButtonClick()" [tabIndex]="0" left>
			{{ "back" | translate }}
		</a>
		<a (click)="onCancelButtonClick()" (keydown.enter)="onCancelButtonClick()" [tabIndex]="0" right>
			{{ "cancel" | translate }}
		</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section">
			<div class="bp-modal-description">
				{{ "tradable_wallet_selection_stack_send" | translate }}
			</div>
			<tradable-wallet
				[ngClass]="'modal-grid mod-two-cols'"
				[action]="'send'"
				[tradableWallets]="walletList"
				(onSelect)="onSelectWallet($event)"
				[tradableId]="tradable?.cryptocoin_id?.toString()">
			</tradable-wallet>
		</div>
	</div>
</div>
